
import { DollarSign, Receipt, TrendingUp, ArrowUp } from "lucide-react";

interface PaymentStatCardsProps {
  totalAmount: number;
  paymentsCount: number;
  averageAmount: number;
  maxAmount: number;
}

export const PaymentStatCards = ({ 
  totalAmount, 
  paymentsCount,
  averageAmount,
  maxAmount 
}: PaymentStatCardsProps) => {
  const stats = [
    {
      label: "Total recaudado",
      value: `$${totalAmount.toLocaleString()}`,
      icon: DollarSign,
      iconBg: "bg-emerald-500/10",
      iconColor: "text-emerald-500",
      borderColor: "border-emerald-500/20",
    },
    {
      label: "Cantidad de pagos",
      value: paymentsCount.toString(),
      icon: Receipt,
      iconBg: "bg-cyan-500/10",
      iconColor: "text-cyan-500",
      borderColor: "border-cyan-500/20",
    },
    {
      label: "Promedio por pago",
      value: `$${Math.round(averageAmount).toLocaleString()}`,
      icon: TrendingUp,
      iconBg: "bg-purple-500/10",
      iconColor: "text-purple-500",
      borderColor: "border-purple-500/20",
    },
    {
      label: "Pago más alto",
      value: `$${maxAmount.toLocaleString()}`,
      icon: ArrowUp,
      iconBg: "bg-amber-500/10",
      iconColor: "text-amber-500",
      borderColor: "border-amber-500/20",
    },
  ];

  return (
    <div className="grid gap-4 grid-cols-2 lg:grid-cols-4">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div 
            key={stat.label}
            className={`glass-card p-4 sm:p-6 rounded-xl border ${stat.borderColor} hover:scale-[1.02] transition-all duration-200 cursor-default`}
            style={{ animationDelay: `${index * 50}ms` }}
          >
            <div className="flex items-start gap-3">
              <div className={`p-2 rounded-lg ${stat.iconBg}`}>
                <Icon className={`h-5 w-5 ${stat.iconColor}`} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs sm:text-sm text-primary/60 truncate">{stat.label}</p>
                <h2 className="text-lg sm:text-2xl font-bold text-primary mt-0.5 truncate">
                  {stat.value}
                </h2>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
